import React from 'react';

/**
 * Campos del formulario del perfil. Centralizan el marcado accesible: el error
 * se anuncia con aria-invalid + aria-describedby en lugar de solo pintarse.
 *
 * `ocultarLabel` deja la etiqueta solo para lectores de pantalla: dentro de
 * una FilaAjuste con un único campo, el título de la fila ya la nombra.
 */

export const CampoTexto = ({
  id, label, hint, error, name, value, onChange,
  type = 'text', autoComplete, disabled, placeholder, onBlur, inputMode, ocultarLabel = false,
}) => (
  <div className="pu-campo">
    <label htmlFor={id} className={ocultarLabel ? 'pu-solo-lectores' : undefined}>{label}</label>
    {hint && <span className="pu-campo-hint" id={`${id}-hint`}>{hint}</span>}
    <input
      id={id}
      name={name}
      type={type}
      value={value ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      placeholder={placeholder}
      autoComplete={autoComplete}
      inputMode={inputMode}
      className={error ? 'input-error' : ''}
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={[hint && `${id}-hint`, error && `${id}-error`].filter(Boolean).join(' ') || undefined}
    />
    {error && <p className="pu-campo-error" id={`${id}-error`}>{error}</p>}
  </div>
);

export const CampoSelect = ({ id, label, hint, name, value, onChange, ocultarLabel = false, children }) => (
  <div className="pu-campo">
    <label htmlFor={id} className={ocultarLabel ? 'pu-solo-lectores' : undefined}>{label}</label>
    {hint && <span className="pu-campo-hint" id={`${id}-hint`}>{hint}</span>}
    <select
      id={id}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      aria-describedby={hint ? `${id}-hint` : undefined}
    >
      {children}
    </select>
  </div>
);
